import React, { useEffect, useState } from 'react';
import { Box, Paper, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Grid } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { getSystemDocumentsModuleFilesApi, getSystemDocumentAssemblyFilesApi } from '../apiService';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { PageLoader, Pagination, STableLoader } from '../../../shared_elements';
import { LeasesBasicDetails, LeasesNav } from '../../elements';
import axios from 'axios';
import { isMobile } from 'react-device-detect';
import FilePreview from '../../../shared_elements/components/FilePreview';
import { Visibility as VisibilityIcon } from '@mui/icons-material';
import fileIcon from '../../assets/img/file_icon.svg'
import PdfIcon from '../../assets/img/pdf_icon.svg'
import XlsxIcon from '../../assets/img/xlsx_icon.svg'
import PngIcon from '../../assets/img/png_icon.svg'
import JpegIcon from '../../assets/img/jpeg_icon.svg'
import JpgIcon from '../../assets/img/jpg_icon.svg'
import DocxIcon from '../../assets/img/docx_icon.svg'
import { trackActivity } from '../../../utils/mixpanel';

const TABLE_HEIGHT = 'calc(100vh - 177px)';

const SystemDocumentsTable = ({ moduleData }) => {
    const params = useParams();
    const { leaseSlug, module, assemblySlug } = params;
    const navigate = useNavigate();
    const location = useLocation();
    const toTitleCase = (str) => str?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) || '';
    const moduleLabel = location.state?.displayName || toTitleCase(module);
    const subFolderName = location.state?.subFolderName;
    const [files, setFiles] = useState(moduleData, { list: [], pagination: null });
    const [loading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filePreviewData, setFilePreviewData] = useState();
    const fileIcons = {
        other: fileIcon,
        pdf: PdfIcon,
        xlsx: XlsxIcon,
        png: PngIcon,
        jpeg: JpegIcon,
        jpg: JpgIcon,
        docx: DocxIcon
    }

    useEffect(() => {
        getSystemDocumentsFiles("skeletonLoader", { per_page: 50 });
        trackActivity('Page Viewed',{ page_title: `System Documents(${params?.module})`})
    }, [])

    const getSystemDocumentsFiles = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        const apiUrl = assemblySlug
            ? getSystemDocumentAssemblyFilesApi(params, query)
            : getSystemDocumentsModuleFilesApi(params, query);
        globalGetService(apiUrl, {})
            .then(response => {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                if (checkApiStatus(response)) {
                    setFiles({ modal: true, data: response?.data?.data });
                }
            });
    };

    const onDownloadAttachment = async (file_url, fileName) => {
        axios.get(file_url, { responseType: 'arraybuffer', })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click()
            })
    }
     const handleItemClicked = (page_type) => {
            trackActivity('Item Clicked', { page_title: `System Documents Listing(${params?.module})`, page_type: page_type, })
        }

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section lease-nav-module-margin lease-module-paper'>
                <LeasesNav />
                <div className='lease-details-content'>
                    <Paper square className="responsive-paper">
                        <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
                            <Grid item md={4} xs={12} className="menu-container" position="relative" top={isMobile ? "20px" : null}>
                                <span className="subfolder-modulelabel"
                                    onClick={() => navigate(assemblySlug
                                        ? `/lease/${leaseSlug}/system-document/${module}/assemblies`
                                        : `/lease/${leaseSlug}/system-documents`
                                    )}
                                >
                                    <Tooltip title="Back">
                                        <ArrowCircleLeftOutlinedIcon sx={{ verticalAlign: '-webkit-baseline-middle', marginBottom: '8px' }} color='primary' fontSize='small' />
                                    </Tooltip>
                                    {assemblySlug ? ` ${moduleLabel}` : ' System Documents'}
                                </span>
                                {assemblySlug && subFolderName && (<span className="sys-doc-subfolder-label">/ {subFolderName}</span>)}
                            </Grid>
                            <Grid item md={8} xs={12}></Grid>
                        </Grid>
                    </Paper>
                    <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: files?.data?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                        <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                            {skeletonLoader ? <STableLoader count={4} rowCount={13} /> : (
                                <Table className='mui-table-format' stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{minWidth: "100px"}}>Action(s)</TableCell>
                                        <TableCell sx={{minWidth: "100px"}}>File Name</TableCell>
                                        <TableCell sx={{ minWidth: "100px" }}>File Size</TableCell>
                                    </TableRow>
                                    </TableHead>
                                            <TableBody>
                                                {files?.data?.list?.length > 0 ? (
                                                    files?.data?.list.map((file) => {
                                                        const ext = file?.file_name.split(".").pop().toLowerCase();
                                                        return (
                                                            <TableRow>
                                                                <TableCell>
                                                                    <Box className='list-inline flex-centered sys-doc-file-actions'>
                                                                        <Tooltip title="Download">
                                                                            <ArrowDownwardIcon onClick={() => {onDownloadAttachment(file?.presigned_url, file?.file_name); handleItemClicked('Download Icon')}} fontSize='small' color='primary' sx={{ cursor: 'pointer' }} />
                                                                        </Tooltip>
                                                                        <Tooltip title="Preview">
                                                                        <VisibilityIcon fontSize="small" color="primary" onClick={() => { setFilePreviewData({ modal: true, data: file });handleItemClicked('Preview Icon') }} sx={{ cursor: "pointer" }} />
                                                                    </Tooltip>
                                                                    </Box>
                                                                </TableCell>
                                                                <TableCell onClick={() => { setFilePreviewData({ modal: true, data: file });handleItemClicked('Preview Icon') }} sx={{ cursor: "pointer" }}>
                                                                    <img src={fileIcons[ext] ? fileIcons[ext] : fileIcons['other']} width='18' alt='file icon' /> 
                                                                    <span className="sys-doc-file-name-text">{file?.file_name ? file?.file_name : "--"}</span></TableCell>
                                                                <TableCell onClick={() => { setFilePreviewData({ modal: true, data: file });handleItemClicked('Preview Icon') }} sx={{ cursor: "pointer" }}>{file?.file_size !== null ? `${file.file_size}` : "--"}</TableCell>
                                                            </TableRow>
                                                        )
                                                    }))
                                                    : (
                                                        <TableRow>
                                                            <TableCell colSpan={3} align="center">No Files Found</TableCell>
                                                        </TableRow>
                                                    )}
                                            </TableBody>
                                </Table>
                            )}
                        </div>
                        <Paper>
                            <Pagination
                                pagination={files?.data?.pagination}
                                onRowsPerPageChange={(e) => getSystemDocumentsFiles("", { page: 1, per_page: e.target.value })}
                                onPageChange={(event, newPage) => getSystemDocumentsFiles("", { page: newPage + 1, per_page: files?.data?.pagination?.per_page })} />
                        </Paper>
                    </Paper>
                </div>
            </Paper>
            {filePreviewData?.modal ?
                <FilePreview
                    filePreview={filePreviewData}
                    onToggleModal={() => setFilePreviewData({ modal: false, data: null })}
                /> : null}
            {loading ? <PageLoader /> : null}
        </>
    );
};

export default SystemDocumentsTable;
